import { useApiRequest } from "@hooks/use-api-request";
import { isNullish } from "@lib/app.helpers";
import { HttpMethod } from "@lib/http.helpers";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useUpdateUserJourney = (onSuccess) => {
  const queryClient = useQueryClient();
  const mutationFn = useApiRequest({
    url: "/users/me/journey",
    method: HttpMethod.Patch,
  });

  return useMutation({
    mutationKey: ["update-user-journey"],
    mutationFn: ({ stepNum, careerId, surveyCompleted }) =>
      mutationFn({
        data: {
          step_num: stepNum,
          career_id: careerId,
          survey_completed: surveyCompleted,
        },
      }),
    onSuccess: (_, variables) => {
      if (!isNullish(variables.careerId)) {
        queryClient.invalidateQueries({ queryKey: ["budget-plan"] });
      }

      queryClient.invalidateQueries({
        queryKey: ["user-journey"],
        exact: true,
      });
      queryClient.invalidateQueries({
        queryKey: ["user-journey-status"],
        exact: true,
      });
      onSuccess?.();
    },
  });
};
